var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agreement_page"},[_c('div',{staticClass:"agreement_title"},[_vm._v(_vm._s(_vm.info.title))]),_c('div',{staticClass:"agreement_content",domProps:{"innerHTML":_vm._s(_vm.info.content)}})])}
var staticRenderFns = []

export { render, staticRenderFns }